import { ActionItem } from '@app/utils/actions';
import { ActionsIcon } from '@app/components/icons/ActionsIcon';
import { Box, ClickAwayListener } from '@mui/material';
import { useRef, useState } from 'react';
import {
  Content,
  Popper,
  ContentWrapper,
  ListItem,
  ArrowContainer,
  Arrow,
  Root,
} from './QuickActionsStyle';

interface QuickActionsProps {
  actions: ActionItem[];
}

function QuickActions({ actions }: QuickActionsProps) {
  const [open, setOpen] = useState<boolean>(false);
  const anchorEl = useRef<null | HTMLElement>(null);

  const toggle = () => {
    setOpen((prev) => !prev);
  };

  const close = () => {
    setOpen(false);
  };

  const childRef = useRef<HTMLDivElement | null>(null);

  return (
    <Root ref={anchorEl}>
      <Box onClick={toggle}>
        <ActionsIcon />
      </Box>
      {open && (
        <ClickAwayListener onClickAway={close}>
          <Popper
            open={open}
            anchorEl={anchorEl.current}
            placement='left'
            disablePortal={true}
            modifiers={[
              {
                name: 'preventOverflow',
                enabled: true,
                options: {
                  altAxis: true,
                  altBoundary: true,
                  tether: true,
                  rootBoundary: 'viewport',
                  padding: 8,
                },
              },
            ]}
          >
            <ContentWrapper>
              <Content>
                {actions.map((item, index) => {
                  return (
                    <ListItem
                      key={index}
                      onClick={
                        item.type === 'function'
                          ? () => childRef.current && childRef.current.click()
                          : item.clickHandler
                      }
                    >
                      {item.type === 'function'
                        ? item.getElement({ onSuccess: close, ref: childRef })
                        : item.label}
                    </ListItem>
                  );
                })}
              </Content>
              <ArrowContainer>
                <Arrow />
              </ArrowContainer>
            </ContentWrapper>
          </Popper>
        </ClickAwayListener>
      )}
    </Root>
  );
}

export default QuickActions;

export const getQuickActions = ({ actions }: QuickActionsProps) => {
  return <QuickActions actions={actions} />;
};
